import apiNaftogazTariffmax from "@/plugins/api/factories/ApiNaftogazTariffmax";

export const state = {
  meterValue: null,
  isSubmitting: false,
  submitResult: null,
};

export const actions = {
  async sendApiNaftogazTariffmaxIndications({ commit, rootState }, meterValue) {
    commit("SET_SUBMITTING", true);
    commit("SET_SUBMIT_RESULT", null);

    const accountData = rootState.Auth.account;

    await apiNaftogazTariffmax.sendApiNaftogazTariffmaxIndications(
      {
        meterValue: meterValue,
        ls: accountData.accountNumber,
        lastName: accountData.lastname,
      },
      (response) => {
        console.log(
          "sendApiNaftogazTariffmaxIndications response",
          JSON.stringify(response)
        );
        commit("SET_SUBMIT_RESULT", response);
        commit("SET_SUBMITTING", false);
      }
    );
  },

  setMeterValue({ commit }, value) {
    commit("SET_METER_VALUE", value);
  },
};

export const mutations = {
  SET_METER_VALUE(state, value) {
    state.meterValue = value;
  },

  SET_SUBMITTING(state, value) {
    state.isSubmitting = value;
  },

  SET_SUBMIT_RESULT(state, value) {
    state.submitResult = value;
  },
};
